export const apiRoutes = {
	dev: 'http://192.168.15.51/api/docloader',
	prod: 'https://doc.alif.tj/api/docloader',
};
